import HTTP from '../HTTP';

const MATERIEL_URL = 'Materiel';

export async function CalculTlpeJourAsync(query) {
  try {
    const response = await HTTP.post(MATERIEL_URL + '/CalculTlpeJourAsync', query);
    return response;
  } catch (e) {
    return null;
  }
}

export async function CalculTlpeSemaineAsync(query) {
  try {
    const response = await HTTP.post(MATERIEL_URL + '/CalculTlpeSemaineAsync', query);
    return response;
  } catch (e) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/api/Materiel/index.js